// import React, { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdLanguage } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const [lang, setLang] = React.useState("en");
  // // const open = Boolean(anchorEl);
  // const pathname = window.location.pathname.split("/");
  // // console.log(pathname, "pathname");
  // const navigate = useNavigate();
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // useEffect(() => {
  //   const lang = localStorage.getItem("language");
  //   if (lang) {
  //     setLang(lang);
  //   }
  // }
  //   , []);

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const languages = {
    en: { name: "English", flag: "🇬🇧" },
    es: { name: "Español", flag: "🇪🇸" },
    de: { name: "Deutsch", flag: "🇩🇪" },
    fr: { name: "Français", flag: "🇫🇷" },
    it: { name: "Italiano", flag: "🇮🇹" },
    pt: { name: "Português", flag: "🇵🇹" },
    ja: { name: "日本語", flag: "🇯🇵" },
    ko: { name: "한국어", flag: "🇰🇷" },
    ar: { name: "العربية", flag: "🇸🇦" },
  };

  const changeLanguage = (event) => {
    const selectedLanguage = event;
    // setLang(event);
    // setAnchorEl(null);
    i18n.changeLanguage(selectedLanguage);
    document.documentElement.lang = selectedLanguage;
    // const dir = i18n.getResource(selectedLanguage, "dir") || "ltr";
    // document.documentElement.dir = dir;
    // document.body.dir = dir;
    localStorage.setItem("language", selectedLanguage);
    // navigate(`/${pathname[2] ? pathname[2] : ""}${pathname[3]?"/"+pathname[3]:""}`);
  };

  return (
    <div>
      {/* <button
        onClick={handleClick}
        variant="contained"
        style={{
          color: "#fff",
          fontSize: "16px",
          textTransform: "none",
          "&:hover": { color: "#fff" },
          "&:focus": { color: "#fff" },
          "&:active": { color: "#fff" },
        }}
      >
        {languages[lang] ? languages[lang]?.name : "English"}
      </button> */}

      <Dropdown className="NavNameImg d-none d-sm-block">
        <Dropdown.Toggle
          className="border-0 bg-transparent togglebtn d-flex align-items-center gap-2 px-0"
          variant=""
          id="dropdown-basic"
          aria-expanded="false"
        >
          {languages[i18n.language.split("-")[0]]?.name || i18n.language}
          <MdLanguage />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu">
          {Object.keys(languages).map((lng) => (
            <Dropdown.Item
              className="dropdown-menu-item"
              key={lng}
              onClick={() => changeLanguage(lng)}
              style={{
                fontSize: "16px",
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
            >
              {languages[lng].name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LanguageSelector;